export default {
  allSeverityLevels: 'Wszystkie poziomy ważności',
  zeroSeverityLevels: 'Wybrano 0 poziomów ważności',
  severityLevels: 'Poziomy ważności',
};
